import React, { Fragment } from 'react';
import { Nav, NavItem } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import "../../App.css";


const HeaderLogin = () => {
  return (
    <div>
      <Nav pullRight>
        <Fragment>
          <LinkContainer to="/login">
            <NavItem>Login</NavItem>
          </LinkContainer>
          <LinkContainer to="/signup">
            <NavItem>Signup</NavItem>
          </LinkContainer>
        </Fragment>
      </Nav>
    </div>
  )
}

export default HeaderLogin;


// WEBPACK FOOTER //
// ./src/components/Header/HeaderLogin.js